import * as UAParser from "ua-parser-js";
export var getDeviceInfo = function () {
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var screenResolution = screenWidth + "x" + screenHeight;
    var colorDepth = window.screen.colorDepth;
    var windowPixelRatio = window.devicePixelRatio;
    var cpuCores = navigator.hardwareConcurrency;
    var parser = new UAParser();
    var os = parser.getOS();
    var device = parser.getDevice();
    var cpu = parser.getCPU();
    var result = parser.getResult();
    return {
        osName: os.name,
        osVersion: os.version,
        deviceType: device.type,
        deviceModel: device.model,
        deviceVendor: device.vendor,
        browserName: result.browser.name,
        browserVersion: result.browser.version,
        cpu: cpu.architecture,
        screenResolution: screenResolution,
        colorDepth: colorDepth,
        windowPixelRatio: windowPixelRatio,
        cpuCores: cpuCores
    };
};
export var getCurrentFingerprint = function () {
    return Object.values(getDeviceInfo()).join('-').toLowerCase();
};
export var createResponse = function (currentHashedFingerprint, fetchedFingerprint, isSameDevice) {
    if (fetchedFingerprint === void 0) { fetchedFingerprint = null; }
    if (isSameDevice === void 0) { isSameDevice = true; }
    return {
        currentFingerprint: currentHashedFingerprint,
        fetchedFingerprint: fetchedFingerprint,
        isSameDevice: isSameDevice,
        unHashedFingerprint: getCurrentFingerprint()
    };
};
